import React from 'react';
import { ButtonBase } from '../elements';
import { FixtureElement } from '../../models/api/codegen/code';
import styled from 'styled-components';
import { format } from 'date-fns';
import { ColoredIcon } from '../Steps/step-parts-components/SportIconAndTitle';
import { HorizontalLine } from '../Steps/step-parts-components/HorizontalLine';
import { useNavigate } from 'react-router-dom';

const MainFoundFixtureWrapper = styled(ButtonBase)`
    display: flex;
    background-color: #171a1e;
    margin-bottom: 1px;
    border-radius: 8px;
    align-items: center;
    width: 100%; 
`;
MainFoundFixtureWrapper.displayName = 'MainFoundFixtureWrapper';

interface MatchBoxBySearchProps {
    fixture: FixtureElement;
    setOpen: (value: boolean) => void;
}

export const MatchBoxBySearch = ({
    fixture,
    setOpen
}: MatchBoxBySearchProps) => {
    const push = useNavigate();

    const path = fixture.s === 'LIVE' ? "/live" : "/prematch";

    const handleClick = () => {
        push('/sport' + path + '/event/' + fixture.fi);
        setOpen(false);
    };

    const nullToZero = (s?: number) => (s ? s : 0);

    return (
        <div className="flex gap-[16px] items-center">
            <ColoredIcon color={fixture.sc} imageUrl={fixture.siu} />
            <button
                className="flex bg-[#171A1E] mb-[1px] rounded-[8px] text-left w-full text-[16px] font-['Roboto'] leading-[100%] font-medium text-[#FFFFFF]"
                onClick={handleClick}
            >
                <div className="py-[21px] px-[16px] flex-grow-[1] basis-0">
                    {fixture.cn}
                </div>
                <div className="py-[21px] px-[16px] basis-0 flex-grow-[1] justify-end flex text-[#ABABAB]">
                    {' '}
                    <div className="pr-[16px] text-[#3FD96E]">
                        {fixture.ms && nullToZero(fixture.fi)}
                    </div>{' '}
                    {fixture.s === 'LIVE' ? (
                        <>
                            <div className="pr-[16px] text-gray">
                                {fixture.ms &&
                                    nullToZero(fixture.ms.homeScore) +
                                        ':' +
                                        nullToZero(fixture.ms.awayScore)}
                            </div>{' '}
                        </>
                    ) : (
                        <></>
                    )}
                    {fixture.st &&
                        format(
                            new Date(String(fixture.st)),
                            'HH:mm dd.MM.yyyy'
                        )}
                </div>
                <div className="flex items-center basis-0 flex-grow-[1] bg-[#121518] py-[21px] px-[16px] rounded-r-lg-[8px] rounded-r-[8px] text-[#D7D8D9]">
                    {' '}
                    <img
                        height={20}
                        className="pr-[16px] h-5"
                        alt={'img'}
                        src={fixture.ciu}
                    />{' '}
                    {fixture.ctn}
                </div>
            </button>
        </div>
    );
};

export const MatchBoxBySearchMobile = ({
    fixture,
    setOpen
}: MatchBoxBySearchProps) => {
    const push = useNavigate();
    const handleClick = () => {
        const p = fixture.s === 'LIVE' ? '/mobile/' : '/';
        push('/sport' + p + fixture.s + '/event/' + fixture.fi);
        setOpen(false);
    };

    const nullToZero = (s?: number) => (s ? s : 0);

    return (
        <div className="bg-[#171a1e] p-[10px] mb-[5px]" onClick={handleClick}>
            {/* Название события с иконкой спорта */}
            <div className="flex items-center gap-[8px] mb-[8px]">
                <div className="w-[20px] h-[20px] flex items-center justify-center flex-shrink-0">
                    <ColoredIcon color={fixture.sc} imageUrl={fixture.siu} />
                </div>
                <div className="text-white text-[12px] font-medium ml-[14px]">
                    {fixture.cn}
                </div>
            </div>

            {/* Информация о матче: ID, период, время, счет */}
            <div className="flex items-center justify-between mb-[8px]">
                <div className="flex items-center gap-[8px] text-[12px]">
                    <span
                        className={`font-medium ${
                            fixture.s === 'LIVE'
                                ? 'text-[#FF9800]'
                                : 'text-[#3FD96E]'
                        } text-[10px]`}
                    >
                        {fixture.fi}
                    </span>
                    {fixture.s === 'LIVE' && fixture.ms && (
                        <span className="text-[#ABABAB] text-[10px] ml-[18px]">
                            {fixture.ms.matchStatus &&
                                `${fixture.ms.matchStatus} `}
                            {fixture.ms.eventClock?.eventTime}
                        </span>
                    )}
                    {fixture.s !== 'LIVE' && fixture.st && (
                        <span className="text-[#ABABAB] text-[10px] ml-[18px]">
                            {format(
                                new Date(String(fixture.st)),
                                'HH:mm dd.MM.yyyy'
                            )}
                        </span>
                    )}
                </div>
                {fixture.ms && (
                    <span className="text-[#FFD700] font-light text-[10px] tracking-[0.35em]">
                        {nullToZero(fixture.ms.homeScore)}:
                        {nullToZero(fixture.ms.awayScore)}
                    </span>
                )}
            </div>

            <div className="-mx-[10px] mb-[8px]">
                <HorizontalLine
                    borderColor={fixture.s === 'LIVE' ? '#F97624BF' : '#3FD96E'}
                />
            </div>

            {/* Название турнира */}
            <div className="flex items-center gap-[8px]">
                <ColoredIcon color={fixture.sc} imageUrl={fixture.siu} />
                <span className="text-[#D7D8D9] text-[10px] ml-[10px]">
                    {fixture.ctn}. {fixture.tn}
                </span>
            </div>
        </div>
    );
};
